import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
interface TrainingPlanWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  existingPlanName: string;
}
export const TrainingPlanWarningModal: React.FC<TrainingPlanWarningModalProps> = ({
  isOpen,
  onClose,
  existingPlanName
}) => {
  return <AnimatePresence data-id="element-1363">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose} data-id="element-1364">
          <motion.div initial={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} animate={{
        scale: 1,
        y: 0,
        opacity: 1
      }} exit={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-gray-900 border border-yellow-500/30 rounded-xl p-8 max-w-lg w-full shadow-[0_20px_50px_-12px_rgba(234,179,8,0.3)] relative" onClick={e => e.stopPropagation()} data-id="element-1365">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" onClick={onClose} data-id="element-1366">
              <XIcon className="w-5 h-5" data-id="element-1367" />
            </button>
            <div className="flex flex-col items-center mb-6" data-id="element-1368">
              <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mb-4" data-id="element-1369">
                <AlertTriangleIcon className="w-8 h-8 text-yellow-500" data-id="element-1370" />
              </div>
              <h3 className="text-2xl font-bold text-yellow-500" data-id="element-1371">Upozornění</h3>
            </div>
            <div className="border-t border-b border-gray-800 py-6 my-6" data-id="element-1372">
              <p className="text-gray-200 text-center mb-6 text-lg leading-relaxed font-light" data-id="element-1373">
                V košíku můžete mít pouze{' '}
                <span className="font-semibold text-white" data-id="element-1374">
                  jeden tréninkový plán
                </span>
                . Pokud si přejete vybrat jiný, nejdříve prosím odstraňte
                aktuální plán z košíku.
              </p>
              <div className="bg-gray-800 rounded-lg p-4 mt-4" data-id="element-1375">
                <p className="text-sm text-gray-400 text-center mb-2" data-id="element-1376">
                  Aktuální plán v košíku:
                </p>
                <p className="text-white font-semibold text-center text-lg" data-id="element-1377">
                  {existingPlanName}
                </p>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-1378">
              <Button variant="primary" onClick={onClose} className="luxury-button px-8" data-id="element-1379">
                ROZUMÍM
              </Button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};